export type OnLayerStateChange = (
  callback: (newState: 'background' | 'foreground') => void,
) => {
  remove: () => void;
};
